import React from 'react';
import { StarIcon } from 'lucide-react';
import { cn } from '../../utils/cn';
export function Rating({
  value,
  count,
  className,
  showCount = true
}: {
  value: number;
  count?: number;
  className?: string;
  showCount?: boolean;
}) {
  return <span className={cn('inline-flex items-center gap-1 text-sm', className)} data-id="element-975" data-mp="3uhxct34e1xa8">
      <StarIcon className="h-4 w-4 fill-accent text-accent" aria-hidden="true" data-id="element-976" data-mp="3ph9nclvt5oi4" />
      <span className="tnum font-semibold text-ink" data-id="element-977" data-mp="31rylf12q1o2e">{value.toFixed(1)}</span>
      {showCount && count !== undefined && <span className="tnum text-ink-3" data-id="element-978" data-mp="2wtndivvzlnmt">({count})</span>}
    </span>;
}
export function StarRow({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex items-center gap-3" data-id="element-979" data-mp="36q0g6j9ifbtp">
      <span className="w-28 shrink-0 text-sm text-ink-2" data-id="element-980" data-mp="36oyuzlys58y9">{label}</span>
      <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-981" data-mp="qxt1p88rcwxe">
        {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className={cn('h-3.5 w-3.5', i <= Math.round(value) ? 'fill-accent text-accent' : 'text-hairline')} data-id="element-982" data-mp="lzj4yt7dxo9o" />)}
      </span>
      <span className="tnum text-sm font-medium text-ink" aria-label={`${label} ${value} out of 5`} data-id="element-983" data-mp="ceuktbwpwgsg">
        {value.toFixed(1)}
      </span>
    </div>;
}